import { BUTTON_ICON_SIZES, BUTTON_PADDING_SIZES } from '../Button/Button.constants';
// Constants.
// -----------------------------------------------------------------------------
export const DEFAULT_MODE = 'light';
export const DEFAULT_POSITION = 'left';
export const DEFAULT_SCHEMA = 'neutral';
export const DEFAULT_SIZE = 's';
export const DEFAULT_VARIANT = 'hard';
export const DROPDOWN_ICON_SIZES = BUTTON_ICON_SIZES;
export const DROPDOWN_PADDING_SIZES = BUTTON_PADDING_SIZES;
export const DROPDOWN_OPTION_SCHEMA = 'neutral';
//# sourceMappingURL=Dropdown.constants.js.map